import { useNavigate } from "react-router-dom";
import { useCalendarEventItem } from "@/entities/calendar-event/model";
import { PersonRecord } from "@/common/PersonRecord";
import { handleFullName } from "@/shared/utils/handle-contacts-null";
import { useRuntimeImage } from "@/entities/runtime-image";
import type { EventTypes } from "@/services/api";
import type { FC } from "react";
import type { Dayjs } from "dayjs";

interface Props {
  type: EventTypes;
  id: string;
  currentDate: Dayjs;
}
export const CalendarBirthdayCard: FC<Props> = ({ type, id, currentDate }) => {
  const { person } = useCalendarEventItem(id, type, currentDate);
  const { getRuntimeImageURL } = useRuntimeImage();
  const navigate = useNavigate();
  const getContent = () => {
    return (
      <div onClick={() => navigate(`/contacts/generalInfo/${person?.id}`)}>
        <PersonRecord
          avatar={getRuntimeImageURL({ fileId: person?.avatarFile?.fileId ?? "" })}
          group={person?.group || ""}
          name={handleFullName(person?.firstName, person?.lastName, person?.middleName)}
          title={person?.title ?? ""}
          avatarSize={"normal"}
        />
      </div>
    );
  };
  return (
    <li>
      <div>{getContent()}</div>
    </li>
  );
};
